import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import classes from './HotelTuple.scss';

import Button from '../../UI/Button/Button';

import HotelTupleWrapper from './HotelTupleWrapper/HotelTupleWrapper';
import TupleBoxLeft from './TupleBoxLeft/TupleBoxLeft';
import TupleBoxCenter from './TupleBoxCenter/TupleBoxCenter';
import TupleBoxRight from './TupleBoxRight/TupleBoxRight'; 
import TupleDivider from './TupleDivider/TupleDivider';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class HotelTuple extends Component {
    chooseRoomHandler = () => {
        const params = new URLSearchParams(this.props.location.search);
        const queryParams = [];
        queryParams.push('supplier=TGU');
        queryParams.push('hotelId=' + this.props.hotel.id);
        queryParams.push('checkInDate=' + params.get("checkInDate"));
        queryParams.push('checkOutDate=' + params.get("checkOutDate"));
        queryParams.push("rooms=" + params.get('rooms'));
        for(let i = 0; i < parseInt(params.get('rooms'), 10); i++) {
            queryParams.push(`rooms${i}noOfAdults=` + params.get(`rooms${i}noOfAdults`));
            queryParams.push(`rooms${i}noOfChildren=` + params.get(`rooms${i}noOfChildren`));
            queryParams.push(`rooms${i}id=` + params.get(`rooms${i}id`));
            queryParams.push(`rooms${i}childArrLength=` + params.get(`rooms${i}childArrLength`));
            for(let j = 0; j < parseInt(params.get(`rooms${i}childArrLength`), 10); j++) {
                queryParams.push(`rooms${i}childrenAge${j}=` + params.get(`rooms${i}childrenAge${j}`));
            }
        }

        const queryString = queryParams.join("&");
        this.props.history.push({
            pathname: "/hotels/details",
            search: "?" + queryString,
        });
    }

    render() {
        const params = new URLSearchParams(this.props.location.search);

        let checkInDate = params.get('checkInDate');
        let checkOutDate = params.get('checkOutDate');

        const totalNights = moment(checkOutDate, 'DD/MM/YYYY').diff(moment(checkInDate, 'DD/MM/YYYY'), 'days');

        let optionsArray = [];
        if(this.props.hotel.isYatraSmart) {
            optionsArray.push('Yatra Smart Choice');
        }
        if(this.props.hotelRate.freeCancel) {
            optionsArray.push('Free Cancellation');
        }
        let freeOptionsArray = this.props.hotelRate.extras || [];
        let stars = [];
        for(let i = 0; i < this.props.hotel.st; i++) {
            stars.push(<span key={i}>&#9733;</span>);
        }

        const options = optionsArray.map((option, index) => {
            return <li key={index} className={`u-fontSize13 u-fontWeightRegular u-textColorNormal u-noWrapWithEllipsis u-lineHeight18`}><span className={`mr-1`}><FontAwesomeIcon icon="check-circle" color="#90BAFF" size="1x" /></span> {option}</li>
        });

        const freeOptions = freeOptionsArray.map((option, index) => {
            return <li key={index} className={`u-fontSize13 u-fontWeightRegular u-textColorNormal u-textEllipsis u-noWrapWithEllipsis u-lineHeight18`}><span className={`mr-1`}>&#9642;</span> {option}</li>
        })

        return (
            <HotelTupleWrapper>
                <TupleBoxLeft isVisible={true}>
                    <div>
                        <img className={`u-width200 u-height200 u-phone-width100Percent u-phone-height140`} src={this.props.hotel.cldImage.url} alt="Hotel" />
                    </div>
                </TupleBoxLeft>
                <TupleBoxCenter>
                    <div className={`mb-6`}>
                        <p className={`u-fontWeightMedium u-fontSize16 u-textColorDark u-noWrapWithEllipsis u-maxWidth380`}>{this.props.hotel.n}</p>
                        <div>
                            <span className={`u-textColorPrimary`}>{stars}</span>
                            <span className={`mt-0 mb-0 ml-2 mr-2 u-textColorNormal`}>&#10072;</span>
                            <span className={`u-fontWeightRegular u-fontSize13 u-textColorNormal`}>{this.props.hotel.loc.a}, {this.props.hotel.loc.c}</span>
                        </div>
                    </div>
                    <div className='u-flex justify-content-between u-minHeight80'>
                        <div className={`u-width100`}>
                            <ul>{freeOptions}</ul>
                        </div>
                        <TupleDivider/>
                        <div className="u-textAlignCenter u-flex f-column justify-content-between" style={{flex: '0 0 8rem'}}>
                            {this.props.hotel.ta ? <React.Fragment>
                                <div className={`${classes.Rating} u-width50 u-height25 u-textColorWhite u-textAlignCenter u-borderRadius4 mx-auto u-fontWeightMedium u-fontSize16`}>{this.props.hotel.ta.rating}</div>
                                <div className={`u-fontWeightMedium u-textColorDark u-fontSize13 mt-auto mb-1 u-lineHeight1`}>{this.props.hotel.ta.rating >= 3 && this.props.hotel.ta.rating <= 4 ? 'Very Good' : this.props.hotel.ta.rating > 4 ? 'Excellent' : ''}</div>
                                <div className={`u-textColorPrimary u-fontSize11`}>{this.props.hotel.ta.reviews} Reviews</div>
                            </React.Fragment> : null}
                        </div>
                        <TupleDivider/>
                        <div className={`u-width150 u-phoneHide`}>
                            <ul>{options}</ul>
                        </div>
                        <div className={`u-phoneShow u-flex f-column justify-content-center align-items-center`}>
                            <div><span className={`u-fontWeightMedium u-textColorDark u-fontSize24`}>&#8377; {this.props.hotelRate.fareBreakup.find(rateType => rateType.label === 'Net Fare').value.toLocaleString()}</span></div>
                            <div><Button onClick={this.chooseRoomHandler} theme="Primary" type="Hotel">Book</Button></div>
                        </div>
                    </div>
                </TupleBoxCenter>
                <TupleBoxRight>
                    <div style={{right: '58px', top: '4px'}} className={`u-absolute`}><span className={`u-fontWeightRegular u-textColorLight u-fontSize11 u-textLineThrough`}>&#8377; {this.props.hotelRate.fareBreakup.find(rateType => rateType.key === 'total').value.toLocaleString()}</span></div>
                    <div className={`u-lineHeight1`}><span className={`u-fontWeightMedium u-textColorDark u-fontSize24 u-lineHeight1`}>&#8377;{this.props.hotelRate.fareBreakup.find(rateType => rateType.key === 'netFare').value.toLocaleString()}</span></div>
                    <div style={{marginTop: '-16px'}} className={`u-lineHeight1`}><span className={`u-fontSize13 u-fontWeightRegular u-textColorLight u-lineHeight1`}>For {totalNights} nights</span></div>
                    <div><span className={`u-fontSize13 u-fontWeightRegular u-textColorGreenDark`}>Your Income &#8377;{this.props.hotelRate.fareBreakup.find(rateType => rateType.key === 'agentProfit').value.toLocaleString()}</span></div>
                    <div><Button onClick={this.chooseRoomHandler} theme="Primary" type="Hotel">Book</Button></div>
                    <div>{this.props.hotelRate.roomsLeft ? <span className={`u-textColorTomato u-fontSize13 u-fontWeightRegular`}>{this.props.hotelRate.roomsLeft} Rooms Left</span> : null }</div>
                </TupleBoxRight>
            </HotelTupleWrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        checkInDate: state.hotelBookingEngine.checkinDate,
        checkOutDate: state.hotelBookingEngine.checkoutDate
    }
}

export default withRouter(connect(mapStateToProps)(HotelTuple));


// WEBPACK FOOTER //
// ./src/components/Hotel/HotelTuple/HotelTuple.js